import { useState, useEffect } from 'react'

const FAVORITES_KEY = 'agentMarketplace_favorites'

export function useFavorites(userId?: string) {
  const [favorites, setFavorites] = useState<string[]>([])

  useEffect(() => {
    if (userId) {
      const stored = localStorage.getItem(`${FAVORITES_KEY}_${userId}`)
      if (stored) {
        setFavorites(JSON.parse(stored))
      }
    }
  }, [userId])

  const toggleFavorite = (agentId: string) => {
    if (!userId) return

    const newFavorites = favorites.includes(agentId)
      ? favorites.filter(id => id !== agentId)
      : [...favorites, agentId]

    setFavorites(newFavorites)
    localStorage.setItem(`${FAVORITES_KEY}_${userId}`, JSON.stringify(newFavorites))
  }

  const isFavorite = (agentId: string) => favorites.includes(agentId)

  return { favorites, toggleFavorite, isFavorite }
}
